import { useState } from 'react';
import { IconButton } from '@zillow/constellation-10';
import { IconAttachmentOutline } from '@zillow/constellation-icons';
import { useCookies } from 'react-cookie';
import AttachmentGuidelines from '../modals/AttachmentGuidelines';

const ATTACHMENT_GUIDELINES_MODAL_COOKIE = 'hasSeenAttachmentGuidelinesModal';

type Props = {
  isDisabled: boolean;
  setIsAttachmentsUploaderOpen: (value: boolean) => void;
};

export default function AddAttachments({ isDisabled, setIsAttachmentsUploaderOpen }: Props) {
  const [cookies, setCookies] = useCookies([ATTACHMENT_GUIDELINES_MODAL_COOKIE]);
  const [isAttachmentGuidelinesModalOpen, setIsAttachmentGuidelinesModalOpen] = useState(false);
  const hasSeenAttachmentGuidelinesModal = cookies[ATTACHMENT_GUIDELINES_MODAL_COOKIE];

  const openAttachmentsUploader = () => setIsAttachmentsUploaderOpen(true);

  const handleCloseAttachmentGuidelinesModalClose = () => {
    setCookies(ATTACHMENT_GUIDELINES_MODAL_COOKIE, 'true', {
      path: '/',
    });
    setIsAttachmentGuidelinesModalOpen(false);
    openAttachmentsUploader();
  };

  const handleAttachmentIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (hasSeenAttachmentGuidelinesModal) {
      openAttachmentsUploader();
    } else {
      setIsAttachmentGuidelinesModalOpen(true);
    }
  };

  return (
    <>
      {isAttachmentGuidelinesModalOpen && <AttachmentGuidelines onClose={handleCloseAttachmentGuidelinesModalClose} />}

      <IconButton
        icon={<IconAttachmentOutline />}
        disabled={isDisabled}
        emphasis="outlined"
        onClick={handleAttachmentIconClick}
        shape="circle"
        size="md"
        title="Attach files or images"
        tone="neutral"
        css={{
          boxShadow: {
            lg: 'none',
          },
        }}
      />
    </>
  );
}
